import { render, staticRenderFns } from "./SpecialResourceTypeSlidebar.vue?vue&type=template&id=f2af8ee8"
import script from "./SpecialResourceTypeSlidebar.vue?vue&type=script&lang=js"
export * from "./SpecialResourceTypeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports